export default class pegPhotoUploadDialog extends HTMLElement {
	connectedCallback() {
		this.abortController = new AbortController();
		this.#setEventListeners();
	}

	disconnectedCallback() {
		this.abortController.abort();
	}

	#setEventListeners() {
		const hasPhotoDescription = this.hasAttribute('enable-photo-description');
		const descriptionTab = this.querySelector("[data-tab='photo-description']");
		const editorTab = this.querySelector("[data-tab='photo-editor']");

		this.querySelector('.save').addEventListener(
			'click',
			async () => {
				this.querySelectorAll('button').forEach((button) => {
					button.setAttribute('disabled', '');
				});
				const description = hasPhotoDescription ? this.querySelector('#pictureSubtext')?.value.trim() : '';
				const image = await this.querySelector('peg-photo-editor').saveAsImage();

				this.#trackSave(description);
				await this.querySelector('peg-photo-uploader').startPhotoUpload(image, description);
				this.querySelectorAll('button').forEach((button) => {
					button.removeAttribute('disabled');
				});
				await this.closest('wdk-dialog').closeModal();
			},
			{ signal: this.abortController?.signal },
		);

		if (hasPhotoDescription) {
			this.querySelector('button.continue').addEventListener(
				'click',
				() => {
					editorTab.setAttribute('inert', '');
					descriptionTab.removeAttribute('inert');
				},
				{ signal: this.abortController?.signal },
			);
			this.querySelector('button.back').addEventListener(
				'click',
				() => {
					descriptionTab.setAttribute('inert', '');
					editorTab.removeAttribute('inert');
				},
				{ signal: this.abortController?.signal },
			);
		}

		this.querySelectorAll('.js-closeDialog').forEach((closeButton) => {
			closeButton.addEventListener(
				'click',
				() => {
					this.#trackAbort();
				},
				{ signal: this.abortController?.signal },
			);
		});
	}

	#trackSave(photoDescription) {
		jPar.util.log.bigData({
			category: this.getAttribute('tracking-category'),
			subcategory: this.getAttribute('tracking-subcategory'),
			targetId: 'button_save',
			action: 'click',
			cd3: photoDescription ? 'with_caption' : 'no_caption',
		});
	}

	#trackAbort() {
		jPar.util.log.bigData({
			category: this.getAttribute('tracking-category'),
			subcategory: this.getAttribute('tracking-subcategory'),
			targetId: 'button_cancel',
			action: 'click',
		});
	}
}
